'use client';

// src/simulated-trade-engine.ts
var D6_SCALE = 1e6;
var STAGE_IDS = [1, 2, 3, 4, 5, 6];
var STAGE_BUTTON = {
  1: { spinner: false, arrow: true, endLine: true },
  2: { spinner: true, arrow: true, endLine: true },
  3: { spinner: true, arrow: true, endLine: true },
  4: { spinner: true, arrow: true, endLine: true },
  5: { spinner: true, arrow: true, endLine: true },
  6: { spinner: true, arrow: false, endLine: false }
};
var NUMBERS = {
  fundingGoal: 1e3,
  fundingStep: 250,
  prizePool: 28400,
  tokens: 850,
  positionCost: 250,
  positionStage3: 610,
  positionStage4: 900,
  sold: 900,
  poolShare: 1500,
  backerRewards: 600,
  putIn: 500,
  gotBack: 3e3,
  profit: 2500,
  multiple: 6
};
var CHART = {
  xs: Array.from({ length: 16 }, (_, i) => 24 + i * ((440 - 24) / 15)),
  yes: [50, 46, 52, 47, 55, 49, 57, 53, 60, 56, 62, 59, 64, 67, 69, 70],
  no: [50, 54, 48, 53, 45, 51, 43, 47, 40, 44, 38, 41, 36, 33, 31, 30],
  target: 70,
  top: 76,
  bottom: 12,
  splitIndex: 11,
  stage3Ms: 6e3,
  stage4Ms: 3200,
  viewWidth: 480,
  axisTicks: [60, 50, 40, 30, 20]
};
var TRADES3 = [
  [150, 180, "no"],
  [520, 240, "yes"],
  [880, 95, "no"],
  [1200, 310, "no"],
  [1560, 120, "yes"],
  [1900, 400, "yes"],
  [2200, 210, "no"],
  [2600, 250, "yes"],
  [3e3, 180, "no"],
  [3350, 640, "yes"],
  [3700, 85, "no"],
  [4050, 260, "no"],
  [4400, 1200, "yes"],
  [4750, 150, "no"],
  [5100, 780, "yes"],
  [5450, 330, "yes"]
];
var TRADES4 = [
  [200, 900, "yes"],
  [600, 140, "no"],
  [1e3, 1500, "yes"],
  [1450, 420, "yes"],
  [1900, 60, "no"],
  [2350, 2e3, "yes"]
];
var SCRIM_FADE_OUT_MS = 250;
var TRADE_LIFE_MS = 2650;
var CHART_RELAYOUT_MS = 900;
function getStageDurationMs(stage) {
  switch (stage) {
    case 1:
      return 3600;
    case 2:
      return 950 + 3 * 850 + 320 + 520 + 900;
    case 3:
      return 700 + CHART.stage3Ms + 500;
    case 4:
      return 300 + CHART.stage4Ms + 1400;
    case 5:
      return 7700;
    case 6:
      return 600 + 7 * 160 + 900 + 300;
    default: {
      const exhaustive = stage;
      return exhaustive;
    }
  }
}
var easeOutCubic = (t) => 1 - (1 - t) ** 3;
var easeInOutCubic = (t) => t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2;
var linear = (t) => t;
function yFor(sharePct, heightPx) {
  return 8 + (CHART.top - sharePct) * ((heightPx - 16) / (CHART.top - CHART.bottom));
}
function yesShareAt(sampleIndex) {
  const last = CHART.yes.length - 1;
  const i = Math.max(0, Math.min(last, Math.floor(sampleIndex)));
  const t = sampleIndex - i;
  const a = CHART.yes[i] ?? 50;
  const b = CHART.yes[Math.min(i + 1, last)] ?? a;
  return a + (b - a) * t;
}
function smoothPath(xs, ys) {
  const pts = xs.map((x, i) => [x, ys[i] ?? 0]);
  const first = pts[0];
  if (first === void 0) return "";
  let d = `M ${first[0]} ${first[1]}`;
  for (let i = 0; i < pts.length - 1; i += 1) {
    const p0 = pts[i - 1] ?? pts[i];
    const p1 = pts[i];
    const p2 = pts[i + 1];
    const p3 = pts[i + 2] ?? p2;
    if (p0 === void 0 || p1 === void 0 || p2 === void 0 || p3 === void 0) continue;
    d += ` C ${p1[0] + (p2[0] - p0[0]) / 6} ${p1[1] + (p2[1] - p0[1]) / 6} ${p2[0] - (p3[0] - p1[0]) / 6} ${p2[1] - (p3[1] - p1[1]) / 6} ${p2[0]} ${p2[1]}`;
  }
  return d;
}
function findSplitFraction(xAt, targetX) {
  let lo = 0;
  let hi = 1;
  let mid = 0.5;
  for (let i = 0; i < 24; i += 1) {
    mid = (lo + hi) / 2;
    if (xAt(mid) < targetX) lo = mid;
    else hi = mid;
  }
  return mid;
}
function usdToD6(usd) {
  return String(Math.round(usd) * D6_SCALE);
}

export {
  STAGE_IDS,
  STAGE_BUTTON,
  NUMBERS,
  CHART,
  TRADES3,
  TRADES4,
  SCRIM_FADE_OUT_MS,
  TRADE_LIFE_MS,
  CHART_RELAYOUT_MS,
  getStageDurationMs,
  easeOutCubic,
  easeInOutCubic,
  linear,
  yFor,
  yesShareAt,
  smoothPath,
  findSplitFraction,
  usdToD6
};
